import { render, staticRenderFns } from "./dormAccess.vue?vue&type=template&id=5d7321dd&"
import script from "./dormAccess.vue?vue&type=script&lang=js&"
export * from "./dormAccess.vue?vue&type=script&lang=js&"
import style0 from "./dormAccess.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports